import i18n from 'i18n';

export const t = (message) => i18n?.t(message);

export const choseLang = (viCase, enCase) => {
  return i18n.language == 'vi' ? viCase : enCase;
};
